import * as etude from "../api/etude";

export const createEtudeAction = (payload) => async (dispatch, getState) => {
  try {
    const resp = await etude.createEtude(payload);

    if (resp.status === 200) {
      console.log("Etude created successfully");
    } else {
      throw new Error("Error creating etude", resp.statusText);
    }
  } catch (error) {
    console.error("Error creating etude", error.message);
    throw new Error("Error creating etude", error.message);
  }
};
